document.addEventListener("DOMContentLoaded", function() {
    const sizeGuideBtn = document.getElementById("sizeGuideBtn");
    const sizeGuideModal = document.getElementById("sizeGuideModal");
    const closeSizeGuide = document.querySelector(".close-size-guide");

    if (sizeGuideBtn) {
        // Mostrar el modal
        sizeGuideBtn.addEventListener("click", function() {
            sizeGuideModal.style.display = "block";
        });

        // Cerrar el modal
        closeSizeGuide.addEventListener("click", function() {
            sizeGuideModal.style.display = "none";
        });

        // Cerrar al hacer clic fuera del modal
        window.addEventListener("click", function(event) {
            if (event.target === sizeGuideModal) {
                sizeGuideModal.style.display = "none";
            }
        });
    }
});
